import { gql } from '@apollo/client';

export const GET_FAILED_TEST_RESULTS_FOR_FRY7Q = gql`
query getFailedTestResultsForFRY7Q($input: GetFailedTestResultsForFRY7QInput) {
  getFailedTestResultsForFRY7Q(input: $input) {
    criteria {
      rowId
      ruleId
      batchId
      regulatorId
      comments
      editType
      editTest
      editNumber
      editChange
      effectiveEndDate
      mdrmNumber
      schedule
      targetItem
    }
    testResults{
      testDate
      testStatus
      errorData
      errorColumns
      errorMessage
      errorDescription
      testPass
      testFail
      testError
      testRunStatus
      remediationCount
    }
    remediation {
      description
      mdrm
      type
      value
    }
  }
}
`;

export const GET_RULE_AUDIT_LOGS_FOR_FRY7Q = gql`
query getAuditLogsForFRY7Q($input: GetAuditLogsForFRY7QInput) {
  getAuditLogsForFRY7Q(input: $input) {
    auditLogId
    eventId
    batchId
    ruleId
    commentId
    userId
    commentText
    user {
      firstName
      lastName
      initials
    }
    event {
      eventName
    }
    comment {
      commentText
    }
    createdAt
  }
}
`;

export const GET_COMMENTS_FOR_FRY7Q = gql`
query getUserCommentsForFRY7Q($input: GetUserCommentForFRY7QInput) {
  getUserCommentsForFRY7Q(input: $input) {
    commentText
    commentId
    userId
    user{
    firstName
    lastName
    initials
  }
  FRY7QAuditLog{
    auditLogId
    eventId
    createdAt
    commentId
  }
  }
}
`;

export const GET_BATCH_TESTS_FOR_FRY7Q = gql`
query getBatchTestsForFRY7Q($input: GetBatchTestsForFRY7QInput) {
  getBatchTestsForFRY7Q(input: $input) {
    batchId,
    ruleId,
    period,
    targetItem,
    schedule,
    mdrmNumber,
    editTest,
    isActive,
    ruleDescription,
    updatedAt,
    totalRecords,
    testPass,
    testFail,
    testError,
    testRunStatus,
    totalBatchTestRecords,
    totalTestCases,
    totalTestCompleted,
    totalTestInError,
    totalTestFailed,
    fileName,
    totalTestExecuted,
    isTopTier,
    topTierApplicable,
    batchRunStatus,
    batchStartTime
  }
}
`;

export const GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FRY7Q = gql`
query getFRY7QBatchTestsByQuarter($input: GetBatchTestsByQuarterInput) {
  getFRY7QBatchTestsByQuarter(input: $input) {
    batchId,
    ruleId,
    period,
    targetItem,
    schedule,
    mdrmNumber,
    editTest,
    isActive,
    ruleDescription,
    updatedAt,
    totalRecords,
    testPass,
    testFail,
    testError,
    testRunStatus,
    totalBatchTestRecords,
    totalTestCases,
    totalTestCompleted,
    totalTestInError,
    totalTestFailed,
    fileName,
    totalTestExecuted,
    isTopTier,
    topTierApplicable,
    batchRunStatus,
    batchStartTime
  }
}`;

export const GET_SUMMARY_QUARTERS_FOR_FRY7Q = gql`
query getSummaryQuartersForFRY7Q($input: TenantIdInput) {
  getSummaryQuartersForFRY7Q(input: $input)
}`;

export const GET_DOWNLOADED_RESULT = gql`
query getFRY7QSummaryDetailsForDownload($input: TenantIdInput) {
  getFRY7QSummaryDetailsForDownload(input: $input) {
    batchId,
    ruleId,
    period,
    targetItem,
    schedule,
    mdrmNumber,
    editTest,
    isActive,
    ruleDescription,
    updatedAt,
    totalRecords,
    testPass,
    testFail,
    testError,
    testRunStatus,
    totalBatchTestRecords,
    totalTestCases,
    totalTestCompleted,
    totalTestInError,
    totalTestFailed,
    fileName,
    totalTestExecuted,
    isTopTier,
    topTierApplicable,
    batchRunStatus,
    batchStartTime
  }
}`;

export const GET_LATEST_BATCH_FOR_FRY7Q = gql`
query getCurrentStatusOfLatestBatchForFRY7Q($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFRY7Q(input: $input) {
    batchRunStatus
    batchId
    batchEndTime
    batchStartTime
    totalRecords
    fileName
    totalTestCases
  }
}`;
